import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useHealth } from "@/context/HealthContext";
import { HCard, RiskBadge } from "@/components/health-kit";
import { Users, ChevronRight, MapPin } from "lucide-react";

export default function Patients() {
  const { ht, tick } = useHealth();
  const navigate = useNavigate();
  const [patients, setPatients] = useState([]);

  useEffect(() => { api.get("/health/patients").then(({ data }) => setPatients(data)).catch(() => {}); }, [tick]);

  return (
    <div className="space-y-6 ngx-fade-in" data-testid="health-patients">
      <div>
        <h1 className="font-display text-2xl font-bold text-slate-50">{ht("nav_patients")}</h1>
        <p className="text-sm text-slate-400 mt-1">{ht("syntheticOnly")} · {ht("notClinical")}</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-5">
        {patients.map((p) => {
          const la = p.latest_analysis;
          return (
            <HCard key={p.id} className="p-5 hover:border-teal-700 transition-colors cursor-pointer"
              data-testid={`patient-card-${p.patient_id}`} onClick={() => navigate(`/health/patients/${p.patient_id}`)}>
              <div className="flex items-start justify-between">
                <div className="flex items-center gap-3">
                  <div className="h-11 w-11 rounded-md bg-teal-600/10 border border-teal-900 flex items-center justify-center">
                    <Users className="h-5 w-5 text-teal-400" />
                  </div>
                  <div>
                    <div className="font-mono text-slate-100 font-semibold">{p.patient_id}</div>
                    <div className="text-xs text-slate-400">{p.age} {ht("years")} · {p.sex}</div>
                  </div>
                </div>
                {la && <RiskBadge level={la.risk_level} ht={ht} />}
              </div>
              <div className="mt-4 flex items-center justify-between text-xs">
                <span className="flex items-center gap-1.5 text-slate-400"><MapPin className="h-3.5 w-3.5" /> {ht("cs_" + p.care_setting)}</span>
                {la && <span className="font-mono text-slate-500">{(la.signals || []).length} {ht("potentialSignals")}</span>}
              </div>
              <div className="mt-4 flex items-center justify-end text-teal-400 text-sm">
                {ht("viewPatient")} <ChevronRight className="h-4 w-4 ml-1" />
              </div>
            </HCard>
          );
        })}
      </div>
    </div>
  );
}
